export const dataset = {
  delete: {
    label: "Delete dataset",
  },
  update: {
    label: "Edit dataset",
  },
  form: {
    name: {
      label: "Name",
    },
    description: {
      label: "Description",
    },
  },
  saveToDelete: "Save to permanently delete",
  zoom: {
    openModal: "Full screen",
  },
  cartesian: {
    imageTitle: "Cartesian image",
    clickableAreaLabel: "Click to define cartesian position",
  },
};
